import type { SxProps, Theme } from '@mui/material';

export const msDefenderIntegrationStyles = {
  loadingState: {
    alignItems: 'center',
    display: 'flex',
    gap: 1,
    py: 1
  },
  queryError: {
    alignItems: 'center',
    gap: 1,
    justifyContent: 'flex-start',
    mb: 2
  },
  stepLabel: {
    color: 'primary.main',
    textTransform: 'uppercase',
    fontWeight: 500
  },
  optionGridItem: {
    display: 'flex'
  }
} satisfies Record<string, SxProps<Theme>>;

export const consentTileStyles = {
  card: {
    backgroundColor: 'background.elevation1',
    display: 'flex',
    flex: 1,
    minWidth: 0
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
    width: '100%'
  },
  capabilityList: {
    color: 'text.secondary',
    li: {
      padding: '0 !important'
    },
    '.MuiListItemText-root': {
      margin: 0.25
    },
    '.MuiListItemIcon-root': {
      minWidth: '1.5rem'
    }
  },
  cardFooter: {
    borderTop: '0.0625rem solid',
    borderColor: 'divider',
    pt: 2,
    alignItems: { xs: 'stretch', sm: 'flex-start' },
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 2,
    justifyContent: 'space-between'
  },
  permissionsAccordion: {
    backgroundColor: 'transparent !important',
    flex: '1 1 auto',
    minWidth: 0,
    '&::before': { display: 'none' }
  },
  permissionsSummary: {
    minHeight: '1rem',
    justifyContent: 'flex-start',
    px: 0,
    '& .MuiAccordionSummary-content': {
      flexGrow: 0,
      marginRight: 0,
      my: 0.75
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      ml: 1,
      color: 'primary.main'
    }
  },
  permissionsDetails: {
    px: 0,
    pb: 0
  },
  scopesStack: {
    flexWrap: 'wrap',
    gap: '0.5rem',
    minWidth: 0
  },
  emptyConnections: {
    borderTop: '0.0625rem solid',
    borderColor: 'divider',
    color: 'text.secondary',
    pt: 2
  },
  connectionRow: {
    borderBottom: '0.0625rem solid',
    borderColor: 'divider',
    py: 2,
    '&:last-of-type': { borderBottom: 0, pb: 0 }
  },
  connectionHeader: {
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: 1,
    justifyContent: 'space-between'
  },
  rowAlert: {
    mt: 1.5,
    '& .MuiAlert-message': { minWidth: 0 }
  },
  warningStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75
  },
  alertMessage: {
    mt: 0.75,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
  },
  recentIssueAlert: {
    mt: 0.5,
    alignItems: 'center',
    '& .MuiAlert-message': {
      overflow: 'hidden',
      py: 0.5
    },
    '& .MuiAlert-action': {
      alignItems: 'center',
      pt: 0,
      mr: 0
    }
  },
  viewHistoryButton: {
    whiteSpace: 'nowrap',
    padding: '0 0.5rem'
  },
  clickableStat: (clickable: boolean) => ({
    cursor: clickable ? 'pointer' : 'default'
  })
} satisfies Record<
  string,
  SxProps<Theme> | ((value: boolean) => SxProps<Theme>)
>;
